import Observer from '../classes/Observer';

class LazyVideo extends Observer {
  constructor($elements = $()) {
    super({
      isOnce: true,
    });

    $elements.each((i, target) => {
      this.observer.observe(target);
    });
  }

  animateIn(target) {
    super.animateIn();
    const $sources = $(target).find('source');

    $sources.each((i, s) => {
      const source = s;
      if (typeof source.tagName === 'string' && source.tagName === 'SOURCE') {
        source.src = source.dataset.src;
      }
    });

    target.load();
  }

  revealTargets($targets) {
    $targets.each((i, target) => {
      this.animateIn(target);
    });
  }
}

export default LazyVideo;
